/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { HydratedRouter } from 'react-router/dom';

import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';

// Sentry.init({
//     dsn: "https://b5070a3bb8ca10c3dbbb04fe2fb0ed29@o4507885294387200.ingest.us.sentry.io/4507885294583808",
//     tracesSampleRate: 1,

//     integrations: [Sentry.browserTracingIntegration({
//       useEffect,
//       useLocation,
//       useMatches
//     }), Sentry.replayIntegration({
//         maskAllText: true,
//         blockAllMedia: true
//     })],

//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1
// })

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
